import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hot", label: "今日热榜" },
  { href: "#categories", label: "吃瓜分类" },
  { href: "#feed", label: "围观广场" },
  { href: "#poll", label: "话题投票" },
  { href: "#about", label: "关于我们" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6 py-3 md:py-4" aria-label="主导航">
        <a href="#top" className="flex items-center gap-2" aria-label="校园吃瓜首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg">🍉</span>
          <span className="font-heading text-lg md:text-xl text-primary-700 whitespace-nowrap">校园吃瓜</span>
        </a>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:block">
          <a
            href="#submit"
            className="inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm text-background-50 hover:bg-primary-600 transition-colors"
          >
            投稿吃瓜
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="lg:hidden flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-900"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm text-background-50"
            >
              投稿吃瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}